// import React, { useState, useEffect } from "react";
// import { MdDateRange, MdLocationOn, MdPerson, MdChevronLeft, MdChevronRight } from "react-icons/md";
// import { FaTools } from "react-icons/fa";
// import "./EventCard.css";

// const EventCard = ({ event }) => {
//   const [current, setCurrent] = useState(0);
//   const [isFlipped, setIsFlipped] = useState(false);

//   const hasPhotos = event?.photos && event.photos.length > 0;

//   useEffect(() => {
//     if (!hasPhotos || event.photos.length <= 1) return;
    
//     const interval = setInterval(() => {
//       setCurrent(prev => (prev + 1) % event.photos.length);
//     }, 4000);
    
//     return () => clearInterval(interval);
//   }, [hasPhotos, event.photos]);

//   const nextSlide = (e) => {
//     e.stopPropagation();
//     if (hasPhotos) {
//       setCurrent(prev => (prev + 1) % event.photos.length);
//     }
//   };

//   const prevSlide = (e) => {
//     e.stopPropagation();
//     if (hasPhotos) {
//       setCurrent(prev => (prev - 1 + event.photos.length) % event.photos.length);
//     }
//   };

//   const goToSlide = (index, e) => {
//     e.stopPropagation();
//     setCurrent(index);
//   };

//   const handleCardClick = () => {
//     setIsFlipped(!isFlipped);
//   };

//   if (!event) return null;

//   return (
//     <div className="flip-card-container">
//       <div 
//         className={`flip-card ${isFlipped ? 'flipped' : ''}`}
//         onMouseEnter={() => setIsFlipped(true)}
//         onMouseLeave={() => setIsFlipped(false)}
//         onClick={handleCardClick}
//       >
//         {/* Front Side */}
//         <div className="flip-card-front">
//           {hasPhotos && (
//             <div className="carousel-container">
//               <div className="carousel-wrapper">
//                 <img
//                   src={event.photos[current]}
//                   alt={`${event.title} - ${current + 1}`}
//                   className="carousel-image"
//                 />
                

                

//               </div>
              
//               {/* Gradient Overlay with Title */}
//               <div className="gradient-overlay">
//                 <h3 className="event-title">{event.title}</h3>
//               </div>
//             </div>
//           )}
//         </div>

//         {/* Back Side */}
//         <div className="flip-card-back">
//           <div className="glassmorphism-content">
//             <h3 className="back-title">{event.title}</h3>
//             <div className="event-details">
//               <div className="detail-item">
//                 <MdDateRange className="detail-icon" />
//                 <span>{event.startDate} to {event.endDate}</span>
//               </div>
//               <div className="detail-item">
//                 <FaTools className="detail-icon" />
//                 <span>{event.type}</span>
//               </div>
//               <div className="detail-item">
//                 <MdLocationOn className="detail-icon" />
//                 <span>{event.venue}</span>
//               </div>
//               <div className="detail-item">
//                 <MdPerson className="detail-icon" />
//                 <span>{event.coordinator}</span>
//               </div>
//             </div>

//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default EventCard;


import React, { useState, useEffect } from "react";
import { MdDateRange, MdLocationOn, MdPerson, MdChevronLeft, MdChevronRight } from "react-icons/md";
import { FaCalendarAlt } from "react-icons/fa";
import "./EventCard.css";

const EventCard = ({ event }) => {
  const [current, setCurrent] = useState(0);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const hasPhotos = event?.photos && event.photos.length > 0;

  const changeCurrent = (newIndex) => {
    if (newIndex === current) return;
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrent(newIndex);
      setTimeout(() => setIsTransitioning(false), 50);
    }, 250);
  };

  useEffect(() => {
    if (!hasPhotos || event.photos.length <= 1) return;
    
    const interval = setInterval(() => {
      setCurrent(prev => {
        const newIndex = (prev + 1) % event.photos.length;
        setIsTransitioning(true);
        setTimeout(() => setIsTransitioning(false), 50);
        return newIndex;
      });
    }, 4000);
    
    return () => clearInterval(interval);
  }, [hasPhotos, event.photos]);

  const nextSlide = () => {
    if (hasPhotos) {
      changeCurrent((current + 1) % event.photos.length);
    }
  };

  const prevSlide = () => {
    if (hasPhotos) {
      changeCurrent((current - 1 + event.photos.length) % event.photos.length);
    }
  };

  const goToSlide = (index) => {
    changeCurrent(index);
  };

  if (!event) return null;

  return (
    <div 
      className={`event-card ${isExpanded ? 'expanded' : ''}`}
      onMouseEnter={() => setIsExpanded(true)}
      onMouseLeave={() => setIsExpanded(false)}
      onClick={() => setIsExpanded(!isExpanded)}
    >
      {hasPhotos && (
        <div className="carousel-container">
          <div className="carousel-wrapper">
            <img
              src={event.photos[current]}
              alt={`${event.title} - ${current + 1}`}
              className={`carousel-image ${isTransitioning ? 'fade-out' : 'fade-in'}`}
            />
            

          </div>
          
          <div className="gradient-overlay-top"></div>
          
          <div className="gradient-overlay">
            <div className="event-basic-info">
              <h3 className="event-title">{event.title}</h3>
              
            </div>
          </div>
          
          <div className={`glassmorphism-panel ${isExpanded ? 'show' : ''}`}>
            <div className="panel-content">
              <div className="additional-info">
                <p><MdPerson /> {event.coordinator}</p>
                {event.type && (
                  <p><FaCalendarAlt /> {event.type}</p>
                )}
              <p><MdDateRange /> {event.startDate}{event.endDate && ` – ${event.endDate}`}</p>
                <p><MdLocationOn /> {event.venue}</p>
                {event.pdf && (
                <a href={event.pdf} target="_blank" rel="noopener noreferrer" className="know-more-btn">
                  Know More
                </a>
              )}
              
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EventCard;